import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { components } from "react-select";
import OptionValueContents from "../OptionValueContents";
import { BaseOption as BaseOptionComponent } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CustomRenderedOption(props) {
  var selectProps = props.selectProps,
    data = props.data,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    isDisabled = props.isDisabled;
  var states = {
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  };
  if (selectProps.renderOption) return /*#__PURE__*/_jsx(components.Option, _extends({}, props, {
    children: selectProps.renderOption(data, states)
  }));
  return /*#__PURE__*/_jsx(BaseOptionComponent, _extends({}, props, {
    children: /*#__PURE__*/_jsx(OptionValueContents, {
      label: data.label,
      statusBadgeProps: data.statusBadgeProps
    })
  }));
}
export default CustomRenderedOption;